import * as React from 'react';
import { Box, Paragraph, Button, Drop, Anchor, List, Grid, Card, CardBody, ResponsiveContext, Layer } from 'grommet';
import { DocumentPdf, Linkedin, Gremlin, Github, Upgrade, Reactjs, Code, Docker, Amazon, Secure, Wordpress, Action, Cubes } from 'grommet-icons';
import { Link } from 'react-router-dom';
import { Heading } from 'grommet';
import Prism from 'prismjs';
import OutsideClickHandler from 'react-outside-click-handler';

import { useSelector, useDispatch } from "react-redux"
import { getPages, setActivePageId } from '../../redux/pages/actions';
import { AppState } from '../../redux/pages/interfaces';
import { useRef, useContext, useEffect } from 'react';
import { themeColors } from '../../utilities/themeColors';
import { Header } from '../../partials/Header';

export const Advisr: React.FC = (props: any): JSX.Element => {

	const pages: any = useSelector((state: AppState) => state.pages);
	const targetRef = useRef() as React.MutableRefObject<HTMLInputElement>;
	const dispatch = useDispatch();
	
	const [isSocialMenuShown, setisSocialMenuShown] = React.useState<boolean>(false);
	let [currentStep, setCurrentStep] = React.useState<number>(1);

	const contributions = [
		'Overall app architecture',
		'ReactJs implementation',
		'Laravel implementation',
		'Set up of CI/CD on AWS architecture',
		'Oauth2 server-to-server integration',
		'Dev team leadership',
		'Built bespoke Wordpress plugin (https://plugins.trac.wordpress.org/browser/advisr-toolbox)',
		'System integrations'
	]
	const roles = [
		'Dev Team Lead',
		'Senior Developer',
		'Solutions architect'
	]

	const technologies = [
		{
			name: 'ReactJs',
			component: <Reactjs size='50px'/>,
			description: 'For the REST API documentation',
		},
		{
			name: 'Laravel',
			component: <Code size='50px'/>,
			description: 'Backend and user pages',
		},
		{
			name: 'Docker',
			component: <Docker size='50px' />,
			description: 'Containerisation of app and dependency layers',
		},
		{
			name: 'OAuth 2.0',
			component: <Secure size='50px' />,
			description: 'Server-to-server authorisation for Google My Business API',
		},
		{
			name: 'AWS',
			component: <Amazon size='50px' />,
			description: 'EC2, CI/CD (Codebuild and Codepipeline), Elastic Beanstalk, EC2, EFS and RDS',
		},
		{
			name: 'Wordpress',
			component: <Wordpress size='50px' />,
			description: 'Bespoke Wordpress plugin for client distribution',
		},
		{
			name: 'REST API',
			component: <Action size='50px' />,
			description: 'For client-side consumption',
		},
		{
			name: 'Web components',
			component: <Cubes size='50px' />,
			description: 'For custom code embeds',
		},
	]
	
	useEffect(() => {
      	dispatch(getPages());
		dispatch(setActivePageId('3'))
	}, []);

	return (
		
		<Box
			fill={true}
			align='center'
			justify='between'
		>
			<Header />
			
			<Box
				style={{ maxWidth: '1000px', width: '100%'}} fill={true} justify='center'>

				{/* tech used */}
				{/* progress */}

				<Box
					direction='row'
					justify='center'
					style={{ maxWidth: '1000px', width: '100%'}}
				>
					{ currentStep === 1 && 
						<Box
							background="neutral"
							alignSelf='center'
							direction='row'
							align='start'
							justify='between'
							style={{ maxWidth: '1000px', width: '100%'}}
						>
							<Box
								background="neutral"
								alignSelf='center'
								direction='column'
								align='start'
								justify='around'
								margin='0'
								basis='1/2'
								flex='grow'
							>
								<Box
									animation={[{type: 'fadeIn'} ]}
									background="neutral"
									>
									<Heading size='45px' margin='10px 0 10px 0'>Project 2/3</Heading>
									<Anchor size='medium' color='neutral-3' label="Advisr.com.au" href="https://advisr.com.au" />
								</Box>
								<Box
									animation={[{type: 'fadeIn', delay: 300 } ]}
									background="neutral"
									>
									<Heading size='45px' margin='30px 0 10px 0'>What is it?</Heading>
									<Paragraph>A Sydney-based web service that connects Australian insurance brokers, brokerages<br />and networks.</Paragraph>
								</Box>
								<Box
									animation={[{type: 'fadeIn', delay: 600 } ]}
									background="neutral"
									>
									<Heading size='45px' margin='10px 0 10px 0'>My roles</Heading>
									<List data={roles} />
								</Box>

							</Box>

							<Box
								background="neutral"
								direction='column'
								align='start'
								justify='around'
							>
								<Box
									animation={[{type: 'fadeIn', delay: 900 } ]}
									background="neutral"
									>
									<Heading size='45px' margin='10px 0 10px 0'>Contributions</Heading>
									<List  data={contributions} />
								</Box>
							</Box>
						</Box>
					}
					{ currentStep === 2 && 
						<Box
							background="neutral"
							alignSelf='center'
							direction='column'
							align='start'
							justify='between'
							style={{ maxWidth: '1000px'}}
						>
							<Box
								alignSelf='center'
								direction='column'
								align='center'
								justify='between'
							>
								<Heading size='35px' margin='10px 0 40px 0'>Technologies used</Heading>

							</Box>
							<Grid gap="small" columns={{ count: 3, size: 'small' }} responsive={true}>
								{ technologies.map((technology, index) => (
									<Card
										pad='0'
										gap='small'
										background='light-2'
										animation={[{type: 'fadeIn', delay: index*200 }, {type: 'slideDown', delay: index*200}]}
									>
										<CardBody pad="0 12px">
											<Box gap="small" align="start" direction="row" pad="small">
												<Box margin='16px 20px 0 0'>
													{technology.component}
												</Box>
												<Box>
													<Heading color={themeColors[Math.floor(Math.random() * themeColors.length)]} size='28px' margin='10px 0 0 0'>{technology.name}</Heading>
													<Paragraph color='dark-3'>{technology.description}</Paragraph>
												</Box>
											</Box>
										</CardBody>
									</Card>
								))}
							</Grid>
						</Box>
					}
				</Box>

				<Box
					justify='between'
					direction='row'
					fill='horizontal'
					margin='100px 0 0 0'
				>			
					{ currentStep === 1 &&		
						<Box>	
							<Link to='/showcase/woodside'>
								<Upgrade 
									size='80px'
									color='status-error'
									style={{ transform: 'rotate(-90deg)', cursor: 'pointer'}}
								/>
							</Link>
							<Paragraph color='dark-3'>Woodside </Paragraph>
						</Box>
					}
					{ currentStep === 2 &&		
						<Box>	
							<Upgrade 
								size='80px'
								color='status-error'
								onClick={()=>setCurrentStep(1)}
								style={{ transform: 'rotate(-90deg)', cursor: 'pointer'}}
							/>
							<Paragraph color='dark-3'>Previous </Paragraph>
						</Box>
					}
					{ currentStep === 1 &&
						<Box>
							<Upgrade 
								size='80px'
								color='status-error'
								onClick={()=>setCurrentStep(2)}
								style={{ transform: 'rotate(90deg)', cursor: 'pointer'}}
							/>
							<Paragraph color='dark-3'>Technology </Paragraph>
						</Box>
					}		
					
					{ currentStep === 2 &&		
						<Box>	
							<Link to='/showcase/evthedev'>
								<Upgrade 
									size='80px'
									color='status-error'
									style={{ transform: 'rotate(90deg)', cursor: 'pointer'}}
								/>
							</Link>
							<Paragraph color='dark-3'>EvTheDev </Paragraph>
						</Box>
					}
				</Box>



			</Box>
			
			

		</Box>

	)
}
Advisr.defaultProps = {
	align: 'center',
	pad: 'large',
  };
  